export const ENV = {
  API_URL: process.env.REACT_APP_API_URL,
  DOMAIN: process.env.REACT_APP_DOMAIN,
  ENVIRONMENT_SUFFIX: process.env.REACT_APP_ENVIRONMENT_SUFFIX,
  DEFAULT_PRODUCT_INCOME_CATEGORY: process.env.REACT_APP_DEFAULT_PRODUCT_INCOME_CATEGORY || 3,
  // CDN_KEY: process.env.REACT_APP_IMAGES,
};
